"use strict";
/**
 * 通用接口定义
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/interface.js
// module id = 826
// module chunks = 37